/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EditShopSourceRequest } from '../models/EditShopSourceRequest';
import type { PaginatedShopSourcesDTO } from '../models/PaginatedShopSourcesDTO';
import type { ShopSourceRequest } from '../models/ShopSourceRequest';
import type { ShopSourceResponse } from '../models/ShopSourceResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ShopSourcesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ShopSourceResponse OK
     * @throws ApiError
     */
    public getShopSourceDetail({
        shopId,
        sourceId,
    }: {
        shopId: string,
        sourceId: string,
    }): CancelablePromise<ShopSourceResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shop-sources/{sourceId}',
            path: {
                'sourceId': sourceId,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public editShopSource({
        sourceId,
        requestBody,
    }: {
        sourceId: string,
        requestBody: EditShopSourceRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/shop-sources/{sourceId}',
            path: {
                'sourceId': sourceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public deleteShopSource({
        shopId,
        sourceId,
    }: {
        shopId: string,
        sourceId: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/shop-sources/{sourceId}',
            path: {
                'sourceId': sourceId,
            },
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopSourceResponse OK
     * @throws ApiError
     */
    public getShopSources({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<Array<ShopSourceResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shop-sources',
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public createShopSource({
        requestBody,
    }: {
        requestBody: ShopSourceRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/shop-sources',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedShopSourcesDTO OK
     * @throws ApiError
     */
    public getShopSourcesSearch({
        shopId,
        search,
        sortBy = 'created_at',
        sort = 'desc',
        page = 1,
        limit = 20,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        sort?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<PaginatedShopSourcesDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shop-sources/search',
            query: {
                'shopId': shopId,
                'search': search,
                'sortBy': sortBy,
                'sort': sort,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
